__turbopack_context__.v({
  "backdrop": "ExperienceLayer-module__Y29L_G__backdrop",
  "layer": "ExperienceLayer-module__Y29L_G__layer",
  "world": "ExperienceLayer-module__Y29L_G__world",
  "worldLive": "ExperienceLayer-module__Y29L_G__worldLive",
  "worldRecede": "ExperienceLayer-module__Y29L_G__worldRecede",
});
